import GeneralHeader from 'components/common/GeneralHeader';
import NewWSCalendar from 'components/tabs-components/general_settings/workshift_calendar/new_workshift_calendar';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import { useState } from 'react';
import { mockKeyStaffLeave } from 'utils/mockData';

const NewWorkshiftCalendar = () => {
  const { createWorkPolicy } = useMember();
  const { successNotification, error } = useNotice();

  const [isSubmit, setIsSubmit] = useState(false);
  const [messageError, setMessageError] = useState('');

  const [state, setState] = useState({
    finalData: {
      name: '',
      comment: '',
      description: '',
      long_description: '',
      french_description: '',
      french_long_description: '',
      workshift_days: [
        {
          week_day: 0,
          is_active: true,
          workshift_1_active: true,
          workshift_1_start_time: '9:00',
          workshift_1_end_time: '12:30',
          workshift_2_active: true,
          workshift_2_start_time: '14:00',
          workshift_2_end_time: '17:30',
          leave_management: 'working',
        },
        {
          week_day: 1,
          is_active: true,
          workshift_1_active: true,
          workshift_1_start_time: '9:00',
          workshift_1_end_time: '12:30',
          workshift_2_active: true,
          workshift_2_start_time: '14:00',
          workshift_2_end_time: '17:30',
          leave_management: 'working',
        },
        {
          week_day: 2,
          is_active: true,
          workshift_1_active: true,
          workshift_1_start_time: '9:00',
          workshift_1_end_time: '12:30',
          workshift_2_active: true,
          workshift_2_start_time: '14:00',
          workshift_2_end_time: '17:30',
          leave_management: 'working',
        },
        {
          week_day: 3,
          is_active: true,
          workshift_1_active: true,
          workshift_1_start_time: '9:00',
          workshift_1_end_time: '12:30',
          workshift_2_active: true,
          workshift_2_start_time: '14:00',
          workshift_2_end_time: '17:30',
          leave_management: 'working',
        },
        {
          week_day: 4,
          is_active: true,
          workshift_1_active: true,
          workshift_1_start_time: '9:00',
          workshift_1_end_time: '12:30',
          workshift_2_active: true,
          workshift_2_start_time: '14:00',
          workshift_2_end_time: '17:30',
          leave_management: 'working',
        },
        {
          week_day: 5,
          is_active: false,
          workshift_1_active: false,
          workshift_1_start_time: '9:00',
          workshift_1_end_time: '12:30',
          workshift_2_active: false,
          workshift_2_start_time: '14:00',
          workshift_2_end_time: '17:30',
          leave_management: 'rest',
        },
        {
          week_day: 6,
          is_active: false,
          workshift_1_active: false,
          workshift_1_start_time: '9:00',
          workshift_1_end_time: '12:30',
          workshift_2_active: false,
          workshift_2_start_time: '14:00',
          workshift_2_end_time: '17:30',
          leave_management: 'rest',
        },
      ],
    },
  });
  const { finalData } = state;

  const addData = (data: any) => {
    setState((pre) => ({
      ...pre,
      finalData: Object.assign(finalData, data),
    }));
  };

  const submit = () => {
    if (isSubmit) return;
    setIsSubmit(true);

    if (finalData?.name === '') {
      setMessageError('Name is required');

      return setIsSubmit(false);
    }
    finalData.workshift_days = finalData.workshift_days.map((item) => {
      if (!item.workshift_1_active && !item.workshift_2_active) {
        item.leave_management = 'rest';
      } else if (!item.is_active) {
        item.is_active = true;
      }
      return item;
    }) as any;
    createWorkPolicy(finalData)
      .then(() => {
        successNotification(
          `"${finalData?.name}"`,
          null,
          ' created successfully.',
        );
        setState({
          finalData: {
            name: '',
            comment: '',
            description: '',
            long_description: '',
            french_description: '',
            french_long_description: '',
            workshift_days: [
              {
                week_day: 0,
                is_active: true,
                workshift_1_active: true,
                workshift_1_start_time: '9:00',
                workshift_1_end_time: '12:30',
                workshift_2_active: true,
                workshift_2_start_time: '14:00',
                workshift_2_end_time: '17:30',
                leave_management: 'working',
              },
              {
                week_day: 1,
                is_active: true,
                workshift_1_active: true,
                workshift_1_start_time: '9:00',
                workshift_1_end_time: '12:30',
                workshift_2_active: true,
                workshift_2_start_time: '14:00',
                workshift_2_end_time: '17:30',
                leave_management: 'working',
              },
              {
                week_day: 2,
                is_active: true,
                workshift_1_active: true,
                workshift_1_start_time: '9:00',
                workshift_1_end_time: '12:30',
                workshift_2_active: true,
                workshift_2_start_time: '14:00',
                workshift_2_end_time: '17:30',
                leave_management: 'working',
              },
              {
                week_day: 3,
                is_active: true,
                workshift_1_active: true,
                workshift_1_start_time: '9:00',
                workshift_1_end_time: '12:30',
                workshift_2_active: true,
                workshift_2_start_time: '14:00',
                workshift_2_end_time: '17:30',
                leave_management: 'working',
              },
              {
                week_day: 4,
                is_active: true,
                workshift_1_active: true,
                workshift_1_start_time: '9:00',
                workshift_1_end_time: '12:30',
                workshift_2_active: true,
                workshift_2_start_time: '14:00',
                workshift_2_end_time: '17:30',
                leave_management: 'working',
              },
              {
                week_day: 5,
                is_active: false,
                workshift_1_active: false,
                workshift_1_start_time: '9:00',
                workshift_1_end_time: '12:30',
                workshift_2_active: false,
                workshift_2_start_time: '14:00',
                workshift_2_end_time: '17:30',
                leave_management: 'rest',
              },
              {
                week_day: 6,
                is_active: false,
                workshift_1_active: false,
                workshift_1_start_time: '9:00',
                workshift_1_end_time: '12:30',
                workshift_2_active: false,
                workshift_2_start_time: '14:00',
                workshift_2_end_time: '17:30',
                leave_management: 'rest',
              },
            ],
          },
        });
        setTimeout(() => {
          setIsSubmit(false);
        }, 1000);
      })
      .catch((err) => {
        const outputObject = Object.fromEntries(
          Object.entries(err?.response?.data).slice(0, 5),
        );

        const divElements = Object.entries(outputObject).map(([key, value]) => {
          setMessageError(
            value[0]
              ? value[0]
              : `Field "${
                  mockKeyStaffLeave[key] ? mockKeyStaffLeave[key] : key
                }"is mandatory`,
          );
          return (
            <div
              style={{ color: '#E02C2C', fontWeight: 400, fontSize: 14 }}
              key={key}
            >
              {value[0] === 'Name is already exists.' ? (
                <p>{value[0]}</p>
              ) : (
                <p>{`Field "${
                  mockKeyStaffLeave[key] ? mockKeyStaffLeave[key] : key
                }" is mandatory`}</p>
              )}
            </div>
          );
        });
        error('Missing or incorrect information', divElements);
        setTimeout(() => {
          setIsSubmit(false);
        }, 1000);
      });
  };
  return (
    <div>
      <GeneralHeader
        icon={'/icons/defalut_setting_ic.svg'}
        pageTitle={'New Work Shift Calendar'}
        btnComponent={
          <button
            onClick={submit}
            style={{ width: 40, height: 40 }}
            className="header-button"
          >
            <img src="/icons/save.svg" alt="button" />
          </button>
        }
        child={
          <div style={{ marginTop: '20px' }}>
            <NewWSCalendar
              finalData={finalData}
              addData={addData}
              isSubmit={isSubmit}
              check={false}
              messageError={messageError}
              setMessageError={setMessageError}
            />
          </div>
        }
      />
    </div>
  );
};

export default NewWorkshiftCalendar;
